module.exports = __webpack_public_path__ + "static/media/home-bg-3.2c367882.jpg";